import {FaWhatsapp} from 'react-icons/fa';
import '../assets/css/botonWhatsapp.css'

function BotonWhatsapp(){
    return(
        <>
            
            <a className='btn-wsp' href='https://wa.me/111541872661' target='__blank'><FaWhatsapp size={40} /></a>
            
        </>
    )
}

export default BotonWhatsapp;